import { useContext, useEffect, useState } from "react";
import { thingsBoardMicroserviceUrl } from "../../../../microservices/thingsboard_microservice";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/InactiveDevicesReports/InactiveDevicesReports.css";
import NewInactiveDevicesReport from "./NewInactiveDevicesReport";
import { Title } from "chart.js";
import InactiveDevicesReport from "./InactiveDevicesReport";
import NavigationBar from "../../../navigation_components/NavigationBar";
import TenantAdministratorSideBar from "../../../sidebar_components/TenantAdministratorSideBar";
import { AppContext } from "../../../AppProvider";
import { InactiveDevicesReportContext } from "./InactiveDevicesReportProvider";

const InactiveDevicesReports = () =>{
    const {user,logout} = useContext(AppContext);
    const {selectedTenantAdminProfile,setSelectedTenantAdminProfile} = useContext(InactiveDevicesReportContext);
    const [tenantAdminProfiles,setTenantAdminProfiles] = useState([]);
    const [serverProfilesFetched,setServerProfilesFetched] = useState(false);
    const [selectedServerUrl] = useState(null);
    const [inactiveDevicesReports,setInactiveDevicesReports] = useState([]);
    const [showInactiveDevicesReport,setShowInactiveDevicesReport] = useState(false);
    const [showNewInactiveDevicesReport,setShowNewInactiveDevicesReport] = useState(false);
    const [selectedInactiveDevicesReport,setSelectedInactiveDevicesReport] = useState(null);
    const fetchServerProfiles = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/all/get`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user?.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(Number(response.status) === 401) logout();
            const responseData = await response.json();
            setTenantAdminProfiles(responseData);
        }
        catch(error){
            console.error(error);
        }
        setServerProfilesFetched(true);
    };
    const fetchInactiveDevicesReports = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/devices/inactive/reports`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user?.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setInactiveDevicesReports(responseData);
            }
            else throw new Error(response.status);
        }
        catch(error){
            console.error('Error');
        }
    };
    const deleteInactiveDevicesReport = async(id) =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/devices/inactive/reports/${id}`;
            const response = await fetch(url,{
                method:'DELETE',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                await fetchInactiveDevicesReports();
            }
            else throw new Error(response.status);
        }
        catch(error){
            console.error(error);
        }
    }
    useEffect(() =>{
        if(serverProfilesFetched) return;
        fetchServerProfiles();
    },[serverProfilesFetched]);
    useEffect(() => {
        if(selectedTenantAdminProfile) fetchInactiveDevicesReports();
    },[selectedTenantAdminProfile,showNewInactiveDevicesReport]);
    useEffect(() =>{
        if(Array.isArray(tenantAdminProfiles)){
            tenantAdminProfiles.forEach(profile =>{
                if(profile?.defaultProfile) setSelectedTenantAdminProfile(profile);
            });
        }
    },[tenantAdminProfiles]);
    return(
        <div className="inactive-devices-reports-page">
            <NavigationBar/>
            <div className="inactive-devices-reports-page-layout">
                <div>
                    <TenantAdministratorSideBar/>
                </div>
                <div className="inactive-devices-reports-parent-container">
                    <div className="inactive-devices-reports-container">
                        <div className="inactive-devices-reports-header-container">
                            <h2>Inactive devices reports</h2>
                            <div className="inactive-devices-reports-header-controls">
                                <select
                                    className="inactive-devices-reports-server-url-select"
                                    onChange={(e) => setSelectedTenantAdminProfile(tenantAdminProfiles?.find(profile => profile?.id === e.target.value))}
                                    value={selectedTenantAdminProfile? selectedTenantAdminProfile?.id:"select"}
                                >
                                    <option value="select" disabled>Server connection</option>
                                    {tenantAdminProfiles.map((tenantAdminProfile,index) => (
                                        <option key={index} value={tenantAdminProfile?.id}>{tenantAdminProfile?.profileName}</option>
                                    ))}
                                </select>
                                <button
                                    className="add-new-inactive-devices-report-button"
                                    style={{display:`${selectedTenantAdminProfile?'block':'none'}`}}
                                    onClick={() => setShowNewInactiveDevicesReport(true)}>
                                    <img src={`${process.env.PUBLIC_URL}/images/add-icon.png`} alt="Add" />
                                </button>
                                <button
                                    className="refresh-inactive-devices-reports-button"
                                    style={{display:`${selectedTenantAdminProfile?'block':'none'}`}}>
                                    <img src={`${process.env.PUBLIC_URL}/images/refresh-icon.png`} alt="Refresh"/>
                                </button>
                            </div>
                        </div>
                        <div style={{display:`${inactiveDevicesReports.length > 0?'block':'none'}`}} className="inactive-devices-reports-body-container">
                            <table>
                                <thead>
                                    <tr id="inactive-devices-reports-table-header-row">
                                        <th style={{width:'20%'}}>Name</th>
                                        <th style={{width:'15%'}}>Date created</th>
                                        <th style={{width:'15%'}}>Time created</th>
                                        <th style={{width:'10%'}}>Devices</th>
                                        <th style={{width:'10%'}}>Schedules</th>
                                        <th style={{width:'10%'}}>Recipients</th>
                                        <th style={{width:'10%'}}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {inactiveDevicesReports.length > 0 && inactiveDevicesReports.map(inactiveDevicesReport =>(
                                        <tr
                                            key={inactiveDevicesReport.id}
                                            onClick={() =>{
                                                setSelectedInactiveDevicesReport(inactiveDevicesReport);
                                                setShowInactiveDevicesReport(true);
                                            }}>
                                            <td>{inactiveDevicesReport.name}</td>
                                            <td>{inactiveDevicesReport.dateCreated}</td>
                                            <td>{inactiveDevicesReport.timeCreated}</td>
                                            <td>{inactiveDevicesReport.devicesCount}</td>
                                            <td>{inactiveDevicesReport.schedulesCount}</td>
                                            <td>{inactiveDevicesReport.recipientsCount}</td>
                                            <td>
                                                <img
                                                    onClick={async(e) => {
                                                        e.stopPropagation();
                                                        await deleteInactiveDevicesReport(inactiveDevicesReport.id)
                                                    }}
                                                    src={`${process.env.PUBLIC_URL}/images/delete-icon.png`}
                                                    title="Delete report"/>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <InactiveDevicesReport
                            user={user}
                            logout={logout}
                            selectedServerUrl={selectedServerUrl}
                            inactiveDevicesReportId={selectedInactiveDevicesReport? selectedInactiveDevicesReport.id:null}
                            showInactiveDevicesReport={showInactiveDevicesReport}
                            setShowInactiveDevicesReport={setShowInactiveDevicesReport}
                        />
                        <NewInactiveDevicesReport
                            user={user}
                            logout={logout}
                            selectedServerUrl={selectedServerUrl}
                            showNewInactiveDevicesReport={showNewInactiveDevicesReport}
                            setShowNewInactiveDevicesReport={setShowNewInactiveDevicesReport}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default InactiveDevicesReports;